import { useEffect } from 'react';

// Radix's dismissable-layer (behind our Dialog / AlertDialog) sets `document.body.style.pointerEvents
// = 'none'` while a modal is open and restores the previous value on close — but it stashes that
// "previous value" in a MODULE-GLOBAL. When a modal is unmounted by a route change instead of being
// closed first (e.g. finishing an exam navigates straight from the runner Dialog to the results
// page), that restore can race — especially with a confirm AlertDialog layered on top — and leave
// the body stuck at `pointer-events: none`. The new page then renders fine but nothing is clickable.
//
// Call this on any page reached by navigating out of a Radix modal: on mount it clears a stuck lock,
// so the page is interactive again. Radix runs its (synchronous) cleanup on unmount before this
// mount effect, so clearing here reliably wins. See radix-ui/primitives issues #2122 / #1241.
export function useReleaseBodyPointerLock(): void {
  useEffect(() => {
    // Only touch the exact value Radix leaves behind — never clobber some other intentional style.
    if (document.body.style.pointerEvents === 'none') {
      document.body.style.pointerEvents = '';
    }
  }, []);
}
